import SectionsData from "modules/shared/profiles/SectionsData";
import { SectionContainer } from "modules/shared/profiles/ViewPaymentInfo";
import React from "react";

function ViewWorkingInfo({ supplierData, organizationData }) {
    return (
        <SectionContainer>
            <SectionsData
                label="Supplier Type"
                text={supplierData?.supplierType?.replaceAll("_", " ")}
            />
            <SectionsData
                label="Truck Types"
                text={supplierData?.truckTypes?.join(",")}
            />
            <SectionsData
                label="Working Governorates"
                text={supplierData?.workingGovernorates
                    ?.map((governorate) => governorate.name)
                    .join(",")}
            />
            {
                organizationData?.organizationType === "supplier_partner" && <SectionsData
                    label="Logistics Partner"
                    text={organizationData?.name}
                />}
        </SectionContainer>
    );
}

export default ViewWorkingInfo;
